import { useMemo } from "react";

import { keyBy } from "lodash";

import { type FetchMmmSummary_me_mmm_summary_accuracyData_data } from "@north-beam/nb-client-side";
import { RecapPerformanceTrackedComponent } from "@pages/mmm/amplitude-tracking/components";
import {
  getMMMEventSelectionData,
  MMMTab,
} from "@pages/mmm/amplitude-tracking/mmm-event";
import { useTrackMMMEvent } from "@pages/mmm/amplitude-tracking/use-track-mmm-event";
import { useClientKpis } from "@pages/mmm/hooks/use-client-kpis";

import { type Kpi } from "../../explore-budgets/client-setting/types";
import { KpiSelect } from "../../shared/kpi-select";

import { SummaryAccuracySummaries } from "./summary-accuracy-summaries";

interface Props {
  selectedKpi: Kpi;
  accuracyData: FetchMmmSummary_me_mmm_summary_accuracyData_data[];
  onChangeKpi: (kpi: Kpi) => void;
}

export const SummaryAccuracy = ({
  selectedKpi,
  accuracyData,
  onChangeKpi,
}: Props) => {
  const trackMMMEvent = useTrackMMMEvent(MMMTab.RECAP_PERFORMANCE);
  const { kpis } = useClientKpis();

  const kpiSelect = {
    label: selectedKpi.friendly_name,
    value: selectedKpi.kpi_name,
  };

  const kpiSelectOptions = useMemo(
    () =>
      kpis.map((kpi) => ({
        label: kpi.friendly_name,
        value: kpi.kpi_name,
      })),
    [kpis],
  );
  const kpisByName = useMemo(() => keyBy(kpis, "kpi_name"), [kpis]);

  return (
    <>
      <div className="text-xl font-bold">Accuracy</div>
      <div className="text-sm">
        Accuracy of the model (generated prior to the period starting) in
        predicting the KPI from your selected setting, at your actual spend
        levels
      </div>
      <div className="flex flex-col">
        <label className="block text-sm mb-1 h-4 max-h-[16px]">KPI</label>
        <KpiSelect
          value={kpiSelect.value}
          onChange={(kpiName) => {
            trackMMMEvent({
              component: RecapPerformanceTrackedComponent.KPI_SELECTOR,
              action: "onSelect",
              data: getMMMEventSelectionData(kpiName),
            });

            onChangeKpi(kpisByName[kpiName]);
          }}
          options={kpiSelectOptions}
          className="h-10"
        />
      </div>
      <SummaryAccuracySummaries
        selectedKpi={selectedKpi}
        accuracyData={accuracyData}
      />
    </>
  );
};
